import React from "react"
import styles from "./CommonFooter.module.scss"
/**
 * 共通フッター
 */
const CommonFooter = () => {
  /*
    今後万が一必要あったとしたら、念のために残しておく。
    const date = new Date()
    Copyright © {date.getFullYear()}
  */
  return (
    <footer className={styles.footer}>
      <span>Copyright©2025</span>
      <br />
      <span>Sompo Direct Insurance Inc.</span>
      <br />
      <span>All Rights Reserved.</span>
    </footer>
  )
}

export default CommonFooter
